/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RecoverEmail
 */
export interface RecoverEmail {
  /**
   *
   * @type {string}
   * @memberof RecoverEmail
   */
  email: string;
}

export function RecoverEmailFromJSON(json: any): RecoverEmail {
  return RecoverEmailFromJSONTyped(json, false);
}

export function RecoverEmailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RecoverEmail {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json['email'],
  };
}

export function RecoverEmailToJSON(value?: RecoverEmail | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
  };
}
